import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
import { PostAlert } from "./AlertActions";
import { getAIOCRSettings } from "../state/aiOCRSlice";
export function GetAIOCRSettings(dispatch) {
  console.log("here? So why not");
  axios.get(`${Globals.baseUrl}/AIOCR/GetAIOCRSettings`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    console.log("res data");
    console.log(res.data);
    if (res.status === 200) {
      dispatch(getAIOCRSettings(res.data));
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((res) => {
  });
}
export function UpdateAIOCRSettings(settings, dispatch) {
  axios.post(`${Globals.baseUrl}/AIOCR/UpdateAIOCRSettings`, settings, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatch(getAIOCRSettings(res.data));
      PostAlert("success", "AI OCR settings updated");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((res) => {
  });
}
